import { render, staticRenderFns } from "./WalletDropdown.vue?vue&type=template&id=8cf9fa16"
import script from "./WalletDropdown.vue?vue&type=script&lang=js"
export * from "./WalletDropdown.vue?vue&type=script&lang=js"
import style0 from "./WalletDropdown.vue?vue&type=style&index=0&id=8cf9fa16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports